import { RuleAction } from "./redirectService";
import { isSignUpSuccess } from "./authRules";
import { navigateToDashboard } from "./redirectActions";

export const ruleActions: RuleAction[] = [
  [isSignUpSuccess, navigateToDashboard],
];
